import { render } from "./beneficiary_map.vue?vue&type=template&id=46a35632&scoped=true"
import script from "./beneficiary_map.vue?vue&type=script&lang=js"
export * from "./beneficiary_map.vue?vue&type=script&lang=js"

import "./beneficiary_map.vue?vue&type=style&index=0&id=46a35632&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a35632"]])

export default __exports__